/**
 * Created by Mark on 17/04/2017.
 */



import BaseStore from './base-store.js';
import InternationalizationConstants from '../constants/internationalization.js';
import Environment from '../constants/environment.js';
import ProductStore from './product-store.js';
class InternationalizationStore extends BaseStore {

    constructor(){
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.locale = this.determineLocaleFromBrowser();
        this.translations = {};
    }

    getTranslation(id , fallback){
        if(!this.translations[id]) return fallback
        return this.translations[id]
    }


    getProduct(){
        return !sessionStorage.product ? "languagenut" : sessionStorage.product;
    }

    removeInstructionsPDF(){
        switch(String(this.determineLocaleFromBrowser()).toLocaleLowerCase())
        {
            case 'sv':
            case 'sv-sv':
                return true;
            default:
                return false
        }
    }

    getInstructionsPDF(){

        switch(String(this.getProduct()))
        {
            case "huber":
            case "hueber":
                    return "Hueber Adminbereich Dokument v2.pdf";
            case "pratstart":
                    return "Pratstart lärarverktygsinstruktioner.pdf";
            default:

                switch(String(this.determineLocaleFromBrowser()).toLocaleLowerCase())
                {
                    case "nl" :
                    case "nl-be" :
                    case "nl-nl" :
                        return "Languagenut Instructions NL.pdf";
                    case "ca" :
                    case "ca-es" :
                    case "es-es" :
                    case "es-mx" :
                        return "Languagenut Instructions ES.pdf";
                    default :

                        return "Languagenut Instructions EN.pdf";
                }

                break
        }
    }

    getModuleTranslation(id){
        console.log(id);
        return this.translations["module-"+id] || " Missing";
    }

    getModuleNoIndexTranslation(id){
        return this.translations['no-index-module-'+id] || "";
    }

    determineLocaleFromBrowser(){

        console.log(ProductStore.productLocale());

        if(ProductStore.productLocale()) return ProductStore.productLocale();


        var defaultLocale = Environment.DEFAULT_LOCALE;
        var supportedLocales = Environment.SUPPORTED_LOCALES;

       /* var localizationLanguage = window.navigator.userLanguage || window.navigator.language || 'en-GB';
        var localizationLanguageParts = localizationLanguage.split('-');
        localizationLanguageParts[localizationLanguageParts.length - 1] = localizationLanguageParts[localizationLanguageParts.length - 1].toUpperCase();

        var desiredLocale = localizationLanguageParts.join('-');

        if (desiredLocale in Object.keys(supportedLocales)) return desiredLocale;

        // We're not supporting this locale yet - do we support an ancestor?
        for (var localeKey in supportedLocales) {
            var supportedLocale = supportedLocales[localeKey];
            var parts = supportedLocale.split('-');
            if (parts[0] == localizationLanguageParts[0]) {
                return supportedLocale; // Top-level is the same
            }
        }*/

        return  window.navigator.userLanguage || window.navigator.language || 'en-GB';
    }

    getlanguageWithoutRegionCode(){
        return this.locale.toLowerCase().split(/[_-]+/)[0];
    }

    getInterfaceTranslations(){
        return this.translations;
    }

    _registerToActions(action) {

        switch(action.actionType){
            case InternationalizationConstants.LOCALE_UPDATE:
                this.locale = action.locale;
                break;
            case InternationalizationConstants.TRANSLATION_UPDATE:

                this.translations = action.response;
                this.translationsFormatted = {};
                this.translationsFormatted[this.locale] = action.response;
                break;
            default: break;
        }

        this.emitChange();
    }
}

export default new InternationalizationStore();


// WEBPACK FOOTER //
// ./src/store/internationalization-store.js